import React, { useState } from "react";

export const Weather = React.createContext(null);

export const WeatherContext = props => {
    const [weather, setWeather] = useState([]);

    const getWeather = (zipCode) => {
        if (zipCode !== null) {
            fetch("https://api.openweathermap.org/data/2.5/forecast?appid=ab99f238288bc36e4a3f8e67b07631b5&zip=" + zipCode)
                .then(response => {
                    response.text().then(text => {
                        const data = text && JSON.parse(text);
                        setWeather(data);
                    });
                })
                .catch(error => {
                    console.log(error);
                });
        }
        else {
            setWeather([]);
        }
    }
    return (
        <>
            <Weather.Provider value={{ weather, getWeather }}>
                {props.children}
            </Weather.Provider>
        </>
    );
}
